import { TService } from 'types/service';

import { CLEAR_SERVICE_CATEGORY, SELECT_SERVICE_CATEGORY } from './ActionTypes';

export function selectServiceCategory(
  category: TService['category_name'] | null,
) {
  return {
    type: SELECT_SERVICE_CATEGORY,
    payload: category,
  };
}

export function clearServiceCategory() {
  return {
    type: CLEAR_SERVICE_CATEGORY,
  };
}
